<template>
    <div class="animated fadeIn h-100 admin-container">
        <div class="page-content">
            <div class="d-flex content-action align-items-center">
                <div class="d-flex align-items-center text-nowrap">
                    <b-button variant="outline-primary" @click="openCreateModal">
                        <i class="fa fa-plus-circle mr-2"></i>
                        <span class="text-uppercase">Thêm lớp dữ liệu</span>
                    </b-button>
                </div>
            </div>
            <b-table
                class="mt-2"
                striped
                hover
                :items="items"
                :fields="fields"
                show-empty
                :current-page="currentPage"
                :per-page="CONSTANTS.ITEM_PER_PAGE"
            >
                <template #cell(index)="data">{{
                    (currentPage - 1) * CONSTANTS.ITEM_PER_PAGE + (data.index + 1)
                }}</template>
                <template v-slot:cell(userId)="row">
                    <span>{{ userName[row.value] }}</span>
                </template>
                <template v-slot:cell(enabled)="data">
                    <b-badge
                        class="px-2 py-1 font-12"
                        :variant="data.value ? 'success' : 'secondary'"
                        >{{ data.value ? 'Bật' : 'Tắt' }}</b-badge
                    >
                </template>
                <template #cell(createdAt)="data">
                    <span>{{ data.value | formatDateTime }}</span>
                </template>
                <template #cell(actions)="row">
                    <b-button
                        variant="primary"
                        class="mr-1 min-width-none"
                        @click="showUpdateModal(row.item.id)"
                        v-b-tooltip.hover
                        :title="$t('common.edit')"
                    >
                        <i class="fa fa-pencil"></i>
                    </b-button>
                    <b-button
                        variant="danger"
                        @click="confirmDelete(row.item.id)"
                        v-b-tooltip.hover
                        class="min-width-none"
                        :title="$t('common.delete')"
                    >
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
                <template v-slot:empty>
                    <div class="text-center">
                        <span>Không có bản ghi nào</span>
                    </div>
                </template>
            </b-table>
            <div v-if="countRow > CONSTANTS.ITEM_PER_PAGE" class="my-1">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="countRow"
                    :per-page="CONSTANTS.ITEM_PER_PAGE"
                    :hide-goto-end-buttons="true"
                    :prev-text="$t('common.prevPage')"
                    :next-text="$t('common.nextPage')"
                    class="my-0"
                    align="center"
                />
            </div>
        </div>

        <!-- Create/Edit Info -->
        <b-modal
            ref="createOrUpdateModal"
            :ok-title="`${itemInfo.id ? $t('common.update') : $t('common.create')}`"
            :title="`${itemInfo.id ? 'Cập nhật thông tin lớp dữ liệu' : 'Tạo mới lớp dữ liệu'}`"
            :cancel-title="$t('common.cancel')"
            @ok="handleCreateOk"
            no-close-on-esc
            no-close-on-backdrop
        >
            <b-form-group :label="$t('common.name')">
                <b-form-input
                    maxlength="255"
                    v-model="itemInfo.name"
                    v-validate="'required'"
                    :placeholder="$t('common.name')"
                    name="name"
                    :data-vv-as="$t('common.name')"
                />
                <div v-show="errors.has('name')" class="validation-message text-danger">
                    {{ errors.first('name') }}
                </div>
            </b-form-group>
            <b-form-group :label="'Biểu tượng'">
                <b-form-radio
                    v-for="(symbol, index) in CONSTANTS.LAYER_SYMBOL"
                    :key="index"
                    name="radio-symbol"
                    :value="symbol"
                    v-model="itemInfo.symbol"
                    ><i :class="`fa fa-${symbol.icon} fa-lg ${symbol.color}`"
                /></b-form-radio>
            </b-form-group>
            <b-form-group label="Trạng thái">
                <b-form-radio-group
                    v-model="itemInfo.enabled"
                    :options="CONSTANTS.LAYER_STATUS"
                    name="radio-status"
                />
            </b-form-group>
        </b-modal>

        <!-- Confirm Delete -->
        <b-modal
            ref="deleteModal"
            :title="$t('common.confirmation')"
            no-close-on-esc
            no-close-on-backdrop
            :ok-title="$t('common.delete')"
            :cancel-title="$t('common.cancel')"
            ok-variant="danger"
            @ok="onDelete"
            >Bạn có chắc chắn muốn xoá lớp dữ liệu này?</b-modal
        >
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import CONSTANTS from '@/constants';
export default {
    mounted: function () {
        this.$nextTick(function () {
            this.getList();
            this.getListUsers();
        });
    },
    computed: {
        ...mapState({
            items: (state) => state.layer.items,
            item: (state) => state.layer.item,
            listUsers: (state) => state.user.users
        }),
        countRow() {
            return this.items.length;
        },
        userName() {
            const user = {};
            this.listUsers.forEach((element) => {
                user[element.id] = element.name;
            });
            return user;
        }
    },
    data() {
        return {
            fields: [
                { tdClass: 'align-middle', key: 'index', label: '#' },
                { tdClass: 'align-middle', key: 'name', label: this.$i18n.t('common.name') },
                {
                    tdClass: 'align-middle',
                    key: 'enabled',
                    label: 'Trạng thái'
                },
                { tdClass: 'align-middle', key: 'userId', label: 'Người tạo' },
                {
                    tdClass: 'align-middle',
                    key: 'createdAt',
                    label: this.$i18n.t('common.lastCreated')
                },
                {
                    thClass: 'fixed-actions-col',
                    key: 'actions',
                    label: this.$i18n.t('common.actions')
                }
            ],
            itemInfo: {
                symbol: {}
            },
            currentId: null,
            currentPage: 1,
            CONSTANTS
        };
    },
    methods: {
        ...mapActions({
            getList: 'layer/getList',
            updateOrCreate: 'layer/updateOrCreate',
            deleteById: 'layer/delete',
            getInfo: 'layer/getInfo',
            getListUsers: 'user/getListUsers'
        }),
        handleCreateOk(modal) {
            modal.preventDefault();
            this.onSubmit();
        },
        onSubmit() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    if (this.itemInfo.id) {
                        this.update();
                    } else {
                        this.add();
                    }
                    this.$refs.createOrUpdateModal.hide();
                    this.$toaster.success(
                        `${
                            this.itemInfo.id
                                ? this.$i18n.t('common.update')
                                : this.$i18n.t('common.create')
                        } lớp dữ liệu thành công`
                    );
                }
            });
        },
        async add() {
            delete this.itemInfo.id;
            await this.updateOrCreate(this.itemInfo);
        },
        async showUpdateModal(id) {
            this.resetForm();
            await this.getInfo({ id: id });
            this.itemInfo = _.cloneDeep(this.item);
            this.$refs.createOrUpdateModal.show();
        },
        async update() {
            await this.updateOrCreate(this.itemInfo);
        },
        async onDelete(modal) {
            modal.preventDefault();
            await this.deleteById({ id: this.currentId });
            if (this.items.length / this.CONSTANTS.ITEM_PER_PAGE === this.currentPage - 1) {
                this.currentPage--;
            }
            this.$refs.deleteModal.hide();
            this.$toaster.success('Xoá lớp dữ liệu thành công!');
        },
        openCreateModal() {
            this.resetForm();
            this.$refs.createOrUpdateModal.show();
        },
        async confirmDelete(zoneId) {
            this.currentId = zoneId;
            this.$refs.deleteModal.show();
        },
        resetForm() {
            this.itemInfo = {
                enabled: CONSTANTS.LAYER_STATUS[0].value,
                symbol: CONSTANTS.LAYER_SYMBOL[0]
            };
        }
    }
};
</script>
